import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductDetail from './pages/ProductDetail';
import CategoryPage from './pages/CategoryPage';
import SearchResults from './pages/SearchResults';
import CartPage from './pages/CartPage';
import Checkout from './pages/Checkout';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/common/ProtectedRoute';
import CheckoutPage from './pages/Checkout';
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import PaymentVerification from './PaymentVerification'
import OrderConfirmation from './components/order/OrderConfirmation' 

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<HomePage />} />
          
          {/* Product Details */}
          <Route path="/product/:id" element={<ProductDetail />} />
          
          {/* Category Page */}
          <Route path="/category/:category" element={<CategoryPage />} />
          
          {/* Search Results */}
          <Route path="/search" element={<SearchResults />} />
          
          {/* Shopping Cart */}
          <Route path="/cart" element={<CartPage />} />
          
          {/* Checkout */}
<Route path="/checkout" element={
  <ProtectedRoute>
    <CheckoutPage />
  </ProtectedRoute>
} />

          {/* Login Page */}
          <Route path="/login" element={<LoginPage />} />

          {/* Register page */}
          <Route path="/register" element={<RegisterPage />} />

          {/* payment verification */}
          <Route path="/payment/verify" element={<PaymentVerification />} />

{/* Order Confirmation */}
<Route path="/orders/:id" element={<OrderConfirmation />} />
          
          {/* 404 Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;